import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';
import * as model from '../lib/catalogModel';

const CatalogContext = createContext(null);

export const CatalogProvider = ({ children }) => {
  const { API_URL } = useAuth();
  const [catalog, setCatalog] = useState(model.FOOTBALL_FALLBACK);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async (attempt = 0) => {
      try {
        const res = await axios.get(`${API_URL}/sports/catalog`);
        if (cancelled) return;
        setCatalog(model.normalizeCatalog(res.data));
        setError(false);
        setLoading(false);
      } catch (e) {
        if (cancelled) return;
        if (attempt < 1) {
          if (cancelled) return;
          return load(attempt + 1); // retry once
        }
        // Keep the football fallback already in state; surface a soft error.
        setError(true);
        setLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, [API_URL]);

  const value = {
    // The raw payload, for consumers that pass it to a pure transform rather
    // than calling the bound helpers (see lib/publicProfile.js).
    catalog,
    loading,
    error,
    sports: model.sportsList(catalog),
    getSport: (slug) => model.getSport(catalog, slug),
    positionsFor: (slug) => model.positionsFor(catalog, slug),
    groupedPositionsFor: (slug) => model.groupedPositionsFor(catalog, slug),
    measurablesFor: (slug) => model.measurablesFor(catalog, slug),
    groupedMeasurablesFor: (slug) => model.groupedMeasurablesFor(catalog, slug),
    rankingServicesFor: (slug) => model.rankingServicesFor(catalog, slug),
    pathwaysFor: (slug) => model.pathwaysFor(catalog, slug),
    sportSlugFor: (name) => model.sportSlugFor(catalog, name),
    statsModeFor: (slug) => model.statsModeFor(catalog, slug),
  };

  return <CatalogContext.Provider value={value}>{children}</CatalogContext.Provider>;
};

export const useCatalog = () => {
  const ctx = useContext(CatalogContext);
  if (!ctx) throw new Error('useCatalog must be used within CatalogProvider');
  return ctx;
};
